module.exports = __webpack_public_path__ + "img/電気回路_1_1.98aa7596.jpeg";